import { MenuItem, Stack, TextField } from "@mui/material"

export function ConditionValueFrequency({ value, onChange }) {
    const freq = value || { interval: 1, period: "Month" }

    return (
        <Stack direction="row" spacing={1}>
            <TextField
                type="number"
                value={freq.interval ?? 1}
                onChange={handleIntervalChange}
                onWheel={(e) => e.target.blur()}
                inputProps={{ min: 1, step: 1 }}
                sx={{ width: 80 }}
            />
            <TextField select value={freq.period || "Month"} onChange={handlePeriodChange} sx={{ minWidth: 100 }}>
                <MenuItem value="Hour">Hour</MenuItem>
                <MenuItem value="Day">Day</MenuItem>
                <MenuItem value="Week">Week</MenuItem>
                <MenuItem value="Month">Month</MenuItem>
                <MenuItem value="Year">Year</MenuItem>
            </TextField>
        </Stack>
    )

    function handleIntervalChange(e) {
        const val = parseInt(e.target.value, 10)
        onChange({ ...freq, interval: isNaN(val) || val < 1 ? 1 : val })
    }

    function handlePeriodChange(e) {
        onChange({ ...freq, period: e.target.value })
    }
}
